

export default {
	name: 'HomeBody',
};
